<script>
import { Swiper, SwiperItem } from 'bxs-ui-vue'
function openFullscreen (elem) {
  if (elem.requestFullScreen) {
    elem.requestFullScreen()
  } else if (elem.mozRequestFullScreen) {
    /* Firefox */
    elem.mozRequestFullScreen()
  } else if (elem.webkitRequestFullScreen) {
    /* Chrome, Safari & Opera */
    elem.webkitRequestFullScreen()
  } else if (elem.webkitEnterFullScreen) {
    elem.webkitEnterFullScreen()
  } else if (elem.msRequestFullScreen) {
    elem.msRequestFullScreen()
  } else {
    console.log('can not fullscreen', elem)
  }
}
// 判断是否处于全屏状态
function isFullScreen () {
  return !!(
    document.fullScreen ||
    document.webkitIsFullScreen ||
    document.mozFullScreen ||
    document.msFullscreenElement ||
    document.fullscreenElement
  )
}

const isApp = window.appBridge && appBridge.checkAppFeature('APP_VIEW')

export default {
  name: 'VideoBanner',
  components: {
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem
  },
  props: {
    poster: {
      type: String,
      require: true
    },
    video: {
      type: String,
      require: true
    },
    banner: {
      type: String,
      default: ''
    },
    videoList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      bannerActive: 0, // 控制banner-btn
      paused: false, // 标志视频是否正在播放
      videoObj: undefined // 保存video对象
    }
  },
  computed: {
    escapeVideoList () {
      const { videoList, poster } = this
      if (!Array.isArray(videoList)) {
        console.warn('videoList无视频地址')
        return [{ bgImg: poster }]
      }
      const fileReg = /(.*\/)*([^.]+)(.*)/gi
      return videoList.map(item => {
        const baseUrl = item.videoUrl
        const url = baseUrl.replace(fileReg, '$1 | $2 | $3')
        const urlAry = url.split(' | ')
        item.videoUrl = `${urlAry[0]}${encodeURIComponent(urlAry[1])}${
          urlAry[2]
        }`
        return item
      })
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化全屏事件
    init () {
      const { videoList } = this
      videoList.forEach((item, index) => {
        const viedos = this.$refs[`myVideo${index}`]
        if (!Array.isArray(viedos)) return
        const videoObj = viedos[0]
        if (!videoObj) return
        videoObj.addEventListener('fullscreenchange', e => {
          if (!isFullScreen()) {
            // 退出全屏
            this.checkPauseVideo(index)
          }
        })
        videoObj.addEventListener('webkitfullscreenchange', e => {
          if (!isFullScreen()) {
            // 退出全屏
            this.checkPauseVideo(index)
          }
        })
      })
    },
    // 监听 swiper 滑动事件
    slide (idx) {
      this.checkPauseVideo()
      this.bannerActive = idx
    },
    // 监听 banner-btn 点击事件
    onBannerTab (idx) {
      this.checkPauseVideo()
      const $bxsSwiper = this.$refs.bxsSwiper
      if (idx === 0 && this.bannerActive === 1) {
        $bxsSwiper.prev()
      } else if (idx === 1 && this.bannerActive === 0) {
        $bxsSwiper.next()
      }
      this.bannerActive = idx
    },
    // 监听 video 点击事件
    onClickVideo (index) {
      const vm = this
      const id = isApp ? 'sp_a' : 'sp_c'
      vm.videoObj = vm.$refs[`myVideo${index}`][0]
      vm.paused = vm.videoObj.paused
      try {
        window.WeiyiStatSDK.submit(id, {
          v: '1.0'
        })
      } catch (error) {}
      vm.videoObj.play()
      setTimeout(function () {
        try {
          openFullscreen(vm.videoObj)
        } catch (error) {
          console.log(error)
        }
      }, 300)
      // const playPromise = vm.videoObj.play()
      // if (playPromise !== undefined) {
      //   playPromise.then(_ => {
      //     console.log('_', _)
      //     setTimeout(function() {
      //       try {
      //         openFullscreen(vm.videoObj)
      //       } catch (error) {
      //         console.log(error)
      //       }
      //     }, 300)
      //   })
      //   .catch(error => {
      //     console.log('error', error)
      //   });
      // }
    },
    // 校验 video 的 paused 状态，设置成暂停状态
    checkPauseVideo (index) {
      const video = this.$refs[`myVideo${index}`][0]
      if (!video.paused) {
        this.paused = false
        video.pause()
        try {
          // 退出全屏
          window.WeiyiStatSDK.submit(isApp ? 'sp_a_exit' : 'sp_c_exit', {
            v: '1.0',
            i: index,
            total_length: video.duration,
            watch_length: video.currentTime
          })
        } catch (error) {}
      }
    }
  }
}
</script>
<template>
  <div class="video-bn-wrapper">
    <bxs-swiper ref="bxsSwiper" :autoplay="false">
      <bxs-swiper-item v-for="(item, index) in escapeVideoList" :key="index">
        <div class="video-show" @click="onClickVideo(index)">
          <p
            class="video-bg"
            :style="{ backgroundImage: `url(${item.bgImg}` }"
          />
          <video
            :ref="`myVideo${index}`"
            playsinline
            webkit-playsinline
            style="z-index: -1"
            width="100%"
            :src="item.videoUrl"
            type="video/mp4"
          />
          <i class="banner-play-icon" />
        </div>
      </bxs-swiper-item>
    </bxs-swiper>
  </div>
</template>
<style lang="postcss" scoped>
@import 'variable.css';
.video-bn-wrapper {
  width: 100%;
  position: relative;
  margin-bottom: -23px;
  .banner-img {
    width: 100%;
    height: 100%;
  }
  .banner-btn {
    width: 100%;
    position: absolute;
    bottom: 42px;
    left: 0;
    text-align: center;
    z-index: 2;
    span {
      position: relative;
      height: 20px;
      line-height: 20px;
      padding: 0 11px;
      box-sizing: border-box;
      font-size: 11px;
      color: #333;
      display: inline-block;
      border-radius: 10px;
      background: #fff;
      &:after {
        content: ' ';
        position: absolute;
        pointer-events: none;
        box-sizing: border-box;
        top: -50%;
        left: -50%;
        right: -50%;
        bottom: -50%;
        transform: scale(0.5);
        border: 0 solid #ccc;
        border-width: 1px;
        border-radius: 20px;
      }
    }
    & > span:nth-child(1) {
      margin-right: 4px;
    }
    span.active {
      background: #ff5000;
      color: #fff;
      border-color: #ff5000;
      &:after {
        border-width: 0;
      }
    }
  }
  .video-show {
    font-size: 0;
    position: relative;
    height: 160px;
    .banner-play-icon {
      display: inline-block;
      width: 45px;
      height: 45px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      display: inline-block;
      margin-top: -12px;
      background-image: url('https://media.winbaoxian.com/autoUpload/common/icon3x_79c728e47e633ce.png');
      background-size: 100%;
      background-repeat: no-repeat;
      z-index: 3;
    }
    video {
      position: relative;
      height: 160px;
    }
    .video-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      top: 0;
      left: 0;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  div.head-pic {
    width: 100%;
    overflow: hidden;
    > img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .wechect-css {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 9 !important;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
    background: #333;
    video {
      height: 100%;
      z-index: 10 !important;
    }
  }
}
</style>

<style>
.video-bn-wrapper {
  .bx-swiper {
    .bx-swiper-paginations {
      bottom: 30px;
    }
  }
}
</style>